import PropTypes from 'prop-types';
import React from 'react';
import S from 'styles/form.scss';
import cx from 'classnames';
import styles from 'styles/input.scss';

class TextArea extends React.Component {
  render() {
    const { label, className, errors, ...props } = this.props;
    const errorMsg = errors.join(', ');
    const wrapperStyles = errorMsg ? cx(styles.errored, className) : className;
    const textAreaStyles = cx(styles.inputElement, S.bigTextArea);
    const labelStyles = errorMsg ? cx(S.label, S.errorLabel) : S.label;
    return (
      <div className={wrapperStyles}>
        <h6 className={labelStyles}>{label}</h6>
        <textarea
          className={textAreaStyles}
          ref={(el) => { this.textAreaRef = el; }}
          {...props}
        />

        {errorMsg &&
          <div className={styles.error}><p className={S.errorMsg}>{errorMsg}</p></div>}
      </div>
    );
  }
}

TextArea.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  errors: PropTypes.array,
  className: PropTypes.string,
};

TextArea.defaultProps = {
  label: '',
  errors: [],
};

export default TextArea;



// WEBPACK FOOTER //
// ./client/app/shared/components/TextArea/index.jsx